import { connect } from 'react-redux';
import { getUserEmail } from 'marketing-website/selectors';
import { showFullForm } from 'marketing-website/actionCreators';
import SignupForm from './SignupForm';

function mapStateToProps(state) {
  return {
    // hardcode this to true so we're able to deploy a csrf fix,
    // until we're able to confirm that the short form is no longer used
    // https://github.com/marvelapp/marvelapp_pie/pull/5013
    showFullForm: true,
    userEmail: getUserEmail(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setShowFullForm: () => dispatch(showFullForm()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignupForm);



// WEBPACK FOOTER //
// ./src/components/modules/SignupForm/index.js